<template>
  <div>
    <Pane title="重新发起简易项目综合评审表" :showRemarks="false">
      <template>重新发起简易项目综合评审表</template>
    </Pane>

    <div class="container">
      <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
        <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                :label-col="{ span: 8 }"
                :wrapper-col="{ span: 12 }">
          <div class="title" style="margin-top: 0">基本信息</div>
          <div class="wrapper">
            <a-row :gutter="16" class="form-panel">
              <a-col :span="12">
                <a-form-item label="项目名称">
                  <a-input v-model="form.projectName" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="项目编码">
                  <a-input v-model="form.projectCode" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="设计编码">
                  <a-input v-model="form.designCode" disabled />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="项目阶段">
                  <a-select v-model="form.phaseCode" disabled placeholder="">
                    <a-select-option v-for="item in designPhaseList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="管理级别">
                  <a-radio-group v-model="form.manageLevel" disabled>
                    <a-radio-button v-for="item in manageLevelList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="要求完成时间">
                  <a-date-picker v-model="form.requireFinishDate" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="参与专业" required>
                  <a-checkbox-group v-model="form.majorsArray">
                    <a-checkbox v-for="item in majorList" :key="item.value" :value="item.value">{{ item.name }}</a-checkbox>
                  </a-checkbox-group>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div class="title">项目成员</div>
          <div class="wrapper">
            <a-row :gutter="16" class="form-panel">
              <a-col :span="12">
                <a-form-item label="项目负责人" required>
                  <EmployeeSelector
                      @change="handlePrjLeaderChange"
                      :value="getPrjLeaderValue()"
                      mode="multiple"
                      :single="false"
                  >
                    <a-button block style="text-align: left; width: 250px;">{{ form.prjLeaderName || "请选择项目负责人" }}</a-button>
                  </EmployeeSelector>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="项目分管总工" required>
                  <a-select
                      show-search
                      :filter-option="$selectFilterOption"
                      label-in-value
                      :value="selectedDeptChiefEngineer"
                      placeholder="请选择项目分管总工"
                      @change="(val) => handlePersonnelSelect(val, 'chiefEngineer')"
                      style="width: 100%"
                  >
                    <a-select-option v-for="item in deptChiefEngineers" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="部门分管负责人" required>
                  <a-select
                      show-search
                      :filter-option="$selectFilterOption"
                      label-in-value
                      :value="selectedMaster"
                      placeholder="请选择部门分管负责人"
                      @change="(val) => handlePersonnelSelect(val, 'deptLeader')"
                      style="width: 100%"
                  >
                    <a-select-option v-for="item in masters" :key="item.userId" :value="item.userId">{{ item.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div class="title">专业人员信息</div>
          <div class="wrapper">
            <div style="max-width: 90%; margin: 0 auto; overflow-x: auto;">
              <a-table
                  style=" background: #fff;"
                  :columns="majorsColumns"
                  :data-source="form.majorsDetail || []"
                  row-key="majorValue"
                  :pagination="false"
                  bordered
                  :scroll="{ x: 1030 }"
              >
              <template slot="majorLeader" slot-scope="text, record">
                <EmployeeSelector
                    @change="(arr) => handleMajorEmployeeChange(arr, record, 'majorLeaderNames', 'majorLeaderIds')"
                    :value="getMajorEmployeeValue(record, 'majorLeaderNames', 'majorLeaderIds')"
                    :single="false"
                >
                  <a-input size="small" style="text-align: left;" :value="record.majorLeaderNames || '请选择'"></a-input>
                </EmployeeSelector>
              </template>
              <template slot="designer" slot-scope="text, record">
                <EmployeeSelector
                    @change="(arr) => handleMajorEmployeeChange(arr, record, 'designerNames', 'designerIds')"
                    :value="getMajorEmployeeValue(record, 'designerNames', 'designerIds')"
                    :single="false"
                >
                  <a-input size="small" style="text-align: left;" :value="record.designerNames || '请选择'"></a-input>
                </EmployeeSelector>
              </template>
              <template slot="reviewer" slot-scope="text, record">
                <EmployeeSelector
                    @change="(arr) => handleMajorEmployeeChange(arr, record, 'reviewerNames', 'reviewerIds')"
                    :value="getMajorEmployeeValue(record, 'reviewerNames', 'reviewerIds')"
                    :single="false"
                >
                  <a-input size="small" style="text-align: left;" :value="record.reviewerNames || '请选择'"></a-input>
                </EmployeeSelector>
              </template>
              <template slot="auditor" slot-scope="text, record">
                <EmployeeSelector
                    @change="(arr) => handleMajorEmployeeChange(arr, record, 'auditorNames', 'auditorIds')"
                    :value="getMajorEmployeeValue(record, 'auditorNames', 'auditorIds')"
                    :single="false"
                >
                  <a-input size="small" style="text-align: left;" :value="record.auditorNames || '请选择'"></a-input>
                </EmployeeSelector>
              </template>
              <template slot="approver" slot-scope="text, record">
                <EmployeeSelector
                    @change="(arr) => handleMajorEmployeeChange(arr, record, 'approverNames', 'approverIds')"
                    :value="getMajorEmployeeValue(record, 'approverNames', 'approverIds')"
                    :single="false"
                >
                  <a-input size="small" style="text-align: left;" :value="record.approverNames || '请选择'"></a-input>
                </EmployeeSelector>
              </template>
              <template slot="remark" slot-scope="text, record">
                <a-input v-model="record.remark" size="small" />
              </template>
            </a-table>
            </div>
          </div>

          <div class="title">子项信息</div>
          <div class="wrapper">
            <div class="hintInit">
              <span class="hintName">提示：第一次策划不确定但后期需增加子项时，也必须选择拆分子项，保证至少一个子项。</span>
            </div>
            <a-form-item label="是否拆分子项" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-switch :checked="!!form.hasSubItem" @change="onHasSubItemChange" />
            </a-form-item>
            <template v-if="form.hasSubItem">
              <div style="max-width: 90%; margin: 0 auto 8px auto; display: flex; gap: 8px;">
                <a-button type="primary" icon="plus" @click="addSubItem">新增</a-button>
                <a-button type="danger" icon="minus" @click="removeSubItem">移除</a-button>
              </div>
              <a-table
                  style="max-width: 90%; margin: 0 auto; background: #fff;"
                  :columns="subItemsColumns"
                  :data-source="form.subItems || []"
                  row-key="_rowKey"
                  :pagination="false"
                  :row-selection="{ selectedRowKeys: selectedSubItemKeys, onChange: onSubItemSelectChange }"
                  bordered
              >
                <template slot="subCode" slot-scope="text, record">
                  <a-input v-model="record.subCode" />
                </template>
                <template slot="subName" slot-scope="text, record">
                  <a-input v-model="record.subName" />
                </template>
                <template slot="majors" slot-scope="text, record">
                  <a-select v-model="record.majors" mode="multiple" style="width: 100%" placeholder="请选择参与专业">
                    <a-select-option v-for="item in majorList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                  </a-select>
                </template>
                <template slot="remark" slot-scope="text, record">
                  <a-input v-model="record.remark" />
                </template>
              </a-table>
            </template>
          </div>

          <div class="title">子项专业人员信息</div>
          <div class="wrapper">
            <a-table
                style="max-width: 90%; margin: 0 auto; background: #fff;"
                :columns="subMajorsColumns"
                :data-source="form.subMajors || []"
                row-key="_rowKey"
                :pagination="false"
                bordered
            >
              <template slot="subDesigner" slot-scope="text, record">
                <a-select
                    mode="multiple"
                    :value="getSubMajorSelectedIds(record, 'designerIds')"
                    @change="(val) => handleSubMajorSelectChange(val, record, 'designerNames', 'designerIds')"
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <a-select-option v-for="opt in getSubMajorOptions(record, 'designerNames', 'designerIds')" :key="opt.userId" :value="opt.userId">{{ opt.name }}</a-select-option>
                </a-select>
              </template>
              <template slot="subReviewer" slot-scope="text, record">
                <a-select
                    mode="multiple"
                    :value="getSubMajorSelectedIds(record, 'reviewerIds')"
                    @change="(val) => handleSubMajorSelectChange(val, record, 'reviewerNames', 'reviewerIds')"
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <a-select-option v-for="opt in getSubMajorOptions(record, 'reviewerNames', 'reviewerIds')" :key="opt.userId" :value="opt.userId">{{ opt.name }}</a-select-option>
                </a-select>
              </template>
              <template slot="subAuditor" slot-scope="text, record">
                <a-select
                    mode="multiple"
                    :value="getSubMajorSelectedIds(record, 'auditorIds')"
                    @change="(val) => handleSubMajorSelectChange(val, record, 'auditorNames', 'auditorIds')"
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <a-select-option v-for="opt in getSubMajorOptions(record, 'auditorNames', 'auditorIds')" :key="opt.userId" :value="opt.userId">{{ opt.name }}</a-select-option>
                </a-select>
              </template>
              <template slot="subApprover" slot-scope="text, record">
                <a-select
                    mode="multiple"
                    :value="getSubMajorSelectedIds(record, 'approverIds')"
                    @change="(val) => handleSubMajorSelectChange(val, record, 'approverNames', 'approverIds')"
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <a-select-option v-for="opt in getSubMajorOptions(record, 'approverNames', 'approverIds')" :key="opt.userId" :value="opt.userId">{{ opt.name }}</a-select-option>
                </a-select>
              </template>
            </a-table>
          </div>

          <div class="title">详细信息</div>
          <div class="wrapper">
            <a-row :gutter="16" class="form-panel">
              <a-col :span="12">
                <a-form-item label="设计评审时间" required>
                  <a-date-picker v-model="form.designReviewDate" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="设计输入下达时间" required>
                  <a-date-picker v-model="form.designInputDate" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="出图时间" required>
                  <a-date-picker v-model="form.drawingDate" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="归档时间" required>
                  <a-date-picker v-model="form.archiveDate" style="width: 100%" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <div>时间先后顺序：设计输入下达-设计评审-出图-归档</div>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="设计输入要求" required>
                  <a-textarea v-model="form.designInputReq" :rows="3" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="评审意见" required>
                  <a-textarea v-model="form.reviewOpinion" :rows="3" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="评审主持人" required>
                  <EmployeeSelector
                      @change="handleEmployeeChange($event, 'reviewHostName', 'reviewHostId')"
                      :value="getEmployeeValue('reviewHostName', 'reviewHostId')"
                  >
                    <a-button block style="text-align: left; width: 250px;">{{ form.reviewHostName || "请选择评审主持人" }}</a-button>
                  </EmployeeSelector>
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <div>其他：1、互提资料贯穿于设计全过程，按设计进度适时开展；2、设计验证活动贯穿于设计全过程，按设计进度适时开展；</div>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="备注">
                  <a-textarea v-model="form.remark" :rows="3" />
                </a-form-item>
              </a-col>
              <a-col :lg="24" :md="24" :sm="24">
                <a-form-item label="附件" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" required extra="(所有项目必须进行项目启动会并上传会议记录)">
                  <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <div class="center">
            <a-space>
              <a-button type="primary" @click="submitReview" :loading="submitting">
                重新提交
              </a-button>
              <a-button @click="goBack">返回</a-button>
            </a-space>
          </div>
        </a-form>
      </a-skeleton>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
import { fetchSimplePlanDetail, resubmitSimplePlan } from '@/api/project-plan/simple-plan';
import { getPersonnel } from "@/api/project-approval/review";
import { parseAttachment, buildAttachmentData } from '@/utils/attachment';
import EmployeeSelector from "@/components/employee-selector";
import Attachment from "@/components/attachment";

export default {
  name: "DesignPlanSimpleReapply",
  components: { EmployeeSelector, Attachment },
  data() {
    return {
      loading: false,
      submitting: false,
      id: "",
      taskId: "",
      instanceId: "",
      deptChiefEngineers: [],
      masters: [],
      selectedDeptChiefEngineer: undefined,
      selectedMaster: undefined,
      form: {
        projectName: "",
        projectCode: "",
        designCode: "",
        phaseCode: "",
        manageLevel: undefined,
        requireFinishDate: null,
        hasSubItem: false,
        majors: "",
        majorsArray: [],
        majorsDetail: [],
        prjLeaderName: "",
        prjLeaderId: "",
        chiefEngineerName: "",
        chiefEngineerId: "",
        deptLeaderName: "",
        deptLeaderId: "",
        designReviewDate: null,
        designInputDate: null,
        drawingDate: null,
        archiveDate: null,
        designInputReq: "",
        reviewOpinion: "",
        reviewHostId: "",
        reviewHostName: "",
        remark: "",
        subItems: [],
        subMajors: [],
        prjLeaderDeptId: "",
        mainDeptId: "",
      },
      fileList: [],
      selectedSubItemKeys: [],
      majorsColumns: [
        { title: '专业名称', dataIndex: 'majorName', width: 100 },
        { title: '专业编号', dataIndex: 'majorCode', width: 120 },
        { title: '专业负责人', dataIndex: 'majorLeaderNames', width: 150, scopedSlots: { customRender: 'majorLeader' } },
        { title: '设计人', dataIndex: 'designerNames', width: 150, scopedSlots: { customRender: 'designer' } },
        { title: '复核人', dataIndex: 'reviewerNames', width: 150, scopedSlots: { customRender: 'reviewer' } },
        { title: '审核人', dataIndex: 'auditorNames', width: 120, scopedSlots: { customRender: 'auditor' } },
        { title: '审定人', dataIndex: 'approverNames', width: 120, scopedSlots: { customRender: 'approver' } },
        { title: '备注', dataIndex: 'remark', width: 120, scopedSlots: { customRender: 'remark' } },
      ],
      subItemsColumns: [
        { title: '子项编号', dataIndex: 'subCode', width: 120, scopedSlots: { customRender: 'subCode' } },
        { title: '子项名称', dataIndex: 'subName', width: 150, scopedSlots: { customRender: 'subName' } },
        { title: '参与专业', dataIndex: 'majors', width: 200, scopedSlots: { customRender: 'majors' } },
        { title: '子项负责人', dataIndex: 'subLeaderName', width: 150 },
        { title: '计划结束日期', dataIndex: 'planEndDate', width: 120 },
        { title: '排序', dataIndex: 'sortNo', width: 80 },
        { title: '备注', dataIndex: 'remark', width: 150, scopedSlots: { customRender: 'remark' } },
      ],
      subMajorsColumns: [
        { title: '子项名称', dataIndex: 'subName', width: 100 },
        { title: '子项编号', dataIndex: 'subCode', width: 100 },
        { title: '专业名称', dataIndex: 'majorName', width: 100 },
        { title: '专业编号', dataIndex: 'majorCode', width: 100 },
        { title: '设计人', dataIndex: 'designerNames', width: 150, scopedSlots: { customRender: 'subDesigner' } },
        { title: '复核人', dataIndex: 'reviewerNames', width: 150, scopedSlots: { customRender: 'subReviewer' } },
        { title: '审核人', dataIndex: 'auditorNames', width: 120, scopedSlots: { customRender: 'subAuditor' } },
        { title: '审定人', dataIndex: 'approverNames', width: 120, scopedSlots: { customRender: 'subApprover' } },
      ],
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    designPhaseList() {
      return this.findDataDict('cosys.designPhase') || [];
    },
    manageLevelList() {
      return this.findDataDict('cosys.manageLevel') || [];
    },
    majorList() {
      return this.findDataDict('cosys.major') || [];
    },
  },
  watch: {
    'form.prjLeaderDeptId': {
      immediate: true,
      handler(val) {
        const orgId = this.form.mainDeptId || val;
        if (orgId) this.fetchPersonnel(orgId);
      }
    },
    'form.majorsArray': {
      immediate: true,
      handler(newMajors) {
        if (!this.form.majorsDetail) {
          this.$set(this.form, 'majorsDetail', []);
        }
        const detail = this.form.majorsDetail;
        const majorMap = {};
        detail.forEach(item => {
          majorMap[item.majorValue] = item;
        });
        const newDetail = [];
        (newMajors || []).forEach(majorValue => {
          const majorItem = this.majorList.find(m => m.value === majorValue);
          if (majorItem) {
            if (majorMap[majorValue]) {
              newDetail.push(majorMap[majorValue]);
            } else {
              newDetail.push({
                majorValue: majorValue,
                majorName: majorItem.name,
                majorCode: majorItem.value || '',
                majorLeaderNames: '',
                majorLeaderIds: '',
                designerNames: '',
                designerIds: '',
                reviewerNames: '',
                reviewerIds: '',
                auditorNames: '',
                auditorIds: '',
                approverNames: '',
                approverIds: '',
                remark: ''
              });
            }
          }
        });
        this.$set(this.form, 'majorsDetail', newDetail);
      }
    },
    'form.subItems': {
      deep: true,
      handler() {
        this.updateSubMajorsFromSubItems();
      }
    },
    'form.majorsDetail': {
      deep: true,
      handler(newDetail) {
        if (!newDetail || !this.form.subMajors) return;
        this.form.subMajors.forEach(subMajor => {
          const majorDetail = newDetail.find(m => m.majorValue === subMajor.majorValue);
          if (majorDetail) {
            ['designer', 'reviewer', 'auditor', 'approver'].forEach(role => {
              const nameField = role + 'Names';
              const idField = role + 'Ids';
              this.$set(subMajor, nameField, majorDetail[nameField] || '');
              this.$set(subMajor, idField, majorDetail[idField] || '');
            });
          }
        });
      }
    }
  },
  mounted() {
    const { taskId, instanceId } = this.$route.query;
    this.taskId = taskId || "";
    this.instanceId = instanceId || "";

    const routeId = this.$route.params.id;
    if (routeId) {
      this.id = routeId;
    } else {
      const { businessKey } = this.$route.query;
      if (businessKey) {
        const parts = businessKey.split(":");
        this.id = parts.length > 1 ? parts[1] : "";
      }
    }

    if (this.taskId && this.instanceId) {
      this.setTaskId(this.taskId);
      this.setInstanceId(this.instanceId);
    }

    this.fetchDetail();
  },
  methods: {
    ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
    fetchDetail() {
      if (!this.id) {
        this.loading = false;
        return;
      }
      this.loading = true;
      fetchSimplePlanDetail(this.id)
          .then(data => {
            if (!data) return;
            // 先重置数组字段
            this.$set(this.form, 'subItems', []);
            this.$set(this.form, 'subMajors', []);
            this.$set(this.form, 'majorsDetail', []);
            this.$set(this.form, 'majorsArray', []);

            // 填充普通字段（排除数组字段和附件字段）
            Object.keys(data).forEach(key => {
              if (data[key] === null || data[key] === undefined) return;
              if (['majors', 'majorsDetail', 'subItems', 'subMajors', 'attachment', 'attachmentPaths'].includes(key)) return;
              this.$set(this.form, key, data[key]);
            });

            // 转换日期字段为 moment 对象
            const dateFields = ['requireFinishDate', 'designReviewDate', 'designInputDate', 'drawingDate', 'archiveDate'];
            dateFields.forEach(field => {
              if (this.form[field]) {
                this.$set(this.form, field, moment(this.form[field]));
              }
            });

            // 处理 hasSubItem
            this.$set(this.form, 'hasSubItem', !!data.hasSubItem);

            // 处理 majorsDetail（补充 majorValue）—— 必须在 majorsArray 之前设置
            const majorsDetail = (data.majorsDetail || []).map(item => ({
              ...item,
              majorValue: item.majorCode || item.majorValue || ''
            }));
            this.$set(this.form, 'majorsDetail', majorsDetail);

            // 处理 majorsArray（触发 watch 同步 majorsDetail）
            this.$set(this.form, 'majorsArray', this.normalizeMajorValue(data.majors));

            // 处理 subItems
            this.$set(this.form, 'subItems', (data.subItems || []).map((item, index) => ({
              ...item,
              _rowKey: item.id || `sub_${index}`,
              majors: this.normalizeMajorValue(item.majors),
              planEndDate: item.planEndDate && item.planEndDate !== '-' ? moment(item.planEndDate) : null
            })));

            // 处理 subMajors
            this.$set(this.form, 'subMajors', (data.subMajors || []).map(item => ({
              ...item,
              _rowKey: item._rowKey || `${item.subCode || ''}_${item.majorCode || ''}_${Math.random()}`
            })));

            // 处理附件
            this.fileList = parseAttachment(data.attachment, data.attachmentPaths);

            this.$nextTick(() => this.syncSelectedPersonnel());
          })
          .finally(() => {
            this.loading = false;
          });
    },
    normalizeMajorValue(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];
      return String(value).split(',').filter(Boolean);
    },
    normalizeMajors(value) {
      return Array.isArray(value) ? value.join(',') : (value || '');
    },
    formatDate(value) {
      if (!value) return '';
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    getEmployeeValue(nameField, idField) {
      const name = this.form[nameField];
      const userId = this.form[idField];
      return name ? [{ name, userId }] : [];
    },
    handleEmployeeChange(arr, nameField, idField) {
      if (arr.length) {
        this.$set(this.form, nameField, arr[0].name);
        this.$set(this.form, idField, arr[0].userId);
      } else {
        this.$set(this.form, nameField, '');
        this.$set(this.form, idField, '');
      }
    },
    async fetchPersonnel(orgId) {
      if (!orgId) return;
      try {
        const res = await getPersonnel(orgId);
        const normalize = items => (items || []).map(item => ({ ...item, userId: item.userId || item.id }));
        this.masters = normalize(res.masters);
        this.deptChiefEngineers = normalize(res.deptChiefEngineers);
        this.$nextTick(() => this.syncSelectedPersonnel());
      } catch (e) {
        console.error('获取人员列表失败', e);
      }
    },
    handlePersonnelSelect(val, type) {
      const nameMap = { deptLeader: 'deptLeaderName', chiefEngineer: 'chiefEngineerName' };
      const idMap = { deptLeader: 'deptLeaderId', chiefEngineer: 'chiefEngineerId' };
      const selectMap = { deptLeader: 'selectedMaster', chiefEngineer: 'selectedDeptChiefEngineer' };
      if (val && val.key) {
        this[selectMap[type]] = val;
        this.$set(this.form, nameMap[type], val.label);
        this.$set(this.form, idMap[type], val.key);
      } else {
        this[selectMap[type]] = undefined;
        this.$set(this.form, nameMap[type], '');
        this.$set(this.form, idMap[type], '');
      }
    },
    syncSelectedPersonnel() {
      this.selectedMaster = this.form.deptLeaderId && this.form.deptLeaderName
        ? { key: this.form.deptLeaderId, label: this.form.deptLeaderName } : undefined;
      this.selectedDeptChiefEngineer = this.form.chiefEngineerId && this.form.chiefEngineerName
        ? { key: this.form.chiefEngineerId, label: this.form.chiefEngineerName } : undefined;
    },
    getPrjLeaderValue() {
      const names = (this.form.prjLeaderName || '').split(',').filter(Boolean);
      const ids = (this.form.prjLeaderId || '').split(',').filter(Boolean);
      return names.map((name, idx) => ({ name, userId: ids[idx] || '' }));
    },
    handlePrjLeaderChange(arr) {
      if (arr.length) {
        this.$set(this.form, 'prjLeaderName', arr.map(item => item.name).join(','));
        this.$set(this.form, 'prjLeaderId', arr.map(item => item.userId).join(','));
      } else {
        this.$set(this.form, 'prjLeaderName', '');
        this.$set(this.form, 'prjLeaderId', '');
      }
    },
    handleMajorEmployeeChange(arr, record, nameField, idField) {
      if (arr.length) {
        this.$set(record, nameField, arr.map(item => item.name).join(','));
        this.$set(record, idField, arr.map(item => item.userId).join(','));
      } else {
        this.$set(record, nameField, '');
        this.$set(record, idField, '');
      }
    },
    getMajorEmployeeValue(record, nameField, idField) {
      const names = (record[nameField] || '').split(',').filter(Boolean);
      const ids = (record[idField] || '').split(',').filter(Boolean);
      return names.map((name, idx) => ({ name, userId: ids[idx] || '' }));
    },
    handleSubMajorSelectChange(selectedIds, record, nameField, idField) {
      const options = this.getSubMajorOptions(record, nameField, idField);
      const selectedNames = selectedIds.map(id => {
        const opt = options.find(o => o.userId === id);
        return opt ? opt.name : '';
      }).filter(Boolean);
      this.$set(record, nameField, selectedNames.join(','));
      this.$set(record, idField, selectedIds.join(','));
    },
    getSubMajorOptions(record, nameField, idField) {
      const majorDetail = (this.form.majorsDetail || []).find(m => m.majorValue === record.majorValue);
      if (!majorDetail) return [];
      const names = (majorDetail[nameField] || '').split(',').filter(Boolean);
      const ids = (majorDetail[idField] || '').split(',').filter(Boolean);
      return names.map((name, idx) => ({ name, userId: ids[idx] || '' }));
    },
    getSubMajorSelectedIds(record, idField) {
      return (record[idField] || '').split(',').filter(Boolean);
    },
    onHasSubItemChange(checked) {
      this.$set(this.form, 'hasSubItem', checked);
      if (!checked) {
        this.$set(this.form, 'subItems', []);
        this.$set(this.form, 'subMajors', []);
      }
    },
    addSubItem() {
      if (!this.form.majorsArray || this.form.majorsArray.length === 0) {
        this.$message.warning('请先选择至少一个参与专业');
        return;
      }
      if (!this.form.subItems) {
        this.$set(this.form, 'subItems', []);
      }
      if (!this.form.subMajors) {
        this.$set(this.form, 'subMajors', []);
      }

      let planEndDateValue = '-';
      if (this.form.requireFinishDate) {
        if (moment.isMoment(this.form.requireFinishDate)) {
          planEndDateValue = this.form.requireFinishDate.format('YYYY-MM-DD');
        } else {
          const parsed = moment(this.form.requireFinishDate);
          planEndDateValue = parsed.isValid() ? parsed.format('YYYY-MM-DD') : '-';
        }
      }

      const newItem = {
        _rowKey: Date.now() + Math.random(),
        subCode: '',
        subName: '',
        majors: [...(this.form.majorsArray || [])],
        subLeaderName: this.form.prjLeaderName || '',
        planEndDate: planEndDateValue,
        sortNo: this.form.subItems.length + 1,
        remark: ''
      };
      this.form.subItems.push(newItem);

      // 自动在子项专业人员信息中添加对应行
      const majors = this.form.majorsArray || [];
      majors.forEach(majorValue => {
        const majorItem = this.majorList.find(m => m.value === majorValue);
        if (majorItem) {
          const majorDetail = (this.form.majorsDetail || []).find(m => m.majorValue === majorValue);
          this.form.subMajors.push({
            _rowKey: newItem._rowKey + '_' + majorValue,
            subName: '',
            subCode: '',
            majorName: majorItem.name,
            majorCode: majorItem.value || '',
            majorValue: majorValue,
            majorLeaderNames: majorDetail ? majorDetail.majorLeaderNames || '' : '',
            majorLeaderIds: majorDetail ? majorDetail.majorLeaderIds || '' : '',
            designerNames: majorDetail ? majorDetail.designerNames || '' : '',
            designerIds: majorDetail ? majorDetail.designerIds || '' : '',
            reviewerNames: majorDetail ? majorDetail.reviewerNames || '' : '',
            reviewerIds: majorDetail ? majorDetail.reviewerIds || '' : '',
            auditorNames: majorDetail ? majorDetail.auditorNames || '' : '',
            auditorIds: majorDetail ? majorDetail.auditorIds || '' : '',
            approverNames: majorDetail ? majorDetail.approverNames || '' : '',
            approverIds: majorDetail ? majorDetail.approverIds || '' : '',
            remark: ''
          });
        }
      });
    },
    removeSubItem() {
      if (this.selectedSubItemKeys.length === 0) {
        this.$message.warning('请先选择要移除的子项');
        return;
      }
      this.$set(this.form, 'subItems', (this.form.subItems || []).filter(
          item => !this.selectedSubItemKeys.includes(item._rowKey)
      ));
      this.selectedSubItemKeys = [];
    },
    onSubItemSelectChange(keys) {
      this.selectedSubItemKeys = keys;
    },
    updateSubMajorsFromSubItems() {
      if (!this.form.subItems || !this.form.subMajors) return;
      const newSubMajors = [];
      this.form.subItems.forEach(item => {
        const majors = item.majors || [];
        majors.forEach(majorValue => {
          const majorItem = this.majorList.find(m => m.value === majorValue);
          if (majorItem) {
            const existing = this.form.subMajors.find(
                sm => (sm._rowKey === item._rowKey || String(sm._rowKey).startsWith(String(item._rowKey) + '_')) && sm.majorValue === majorValue
            );
            if (existing) {
              existing.subName = item.subName || '';
              existing.subCode = item.subCode || '';
              newSubMajors.push(existing);
            } else {
              const majorDetail = (this.form.majorsDetail || []).find(m => m.majorValue === majorValue);
              newSubMajors.push({
                _rowKey: item._rowKey + '_' + majorValue,
                subName: item.subName || '',
                subCode: item.subCode || '',
                majorName: majorItem.name,
                majorCode: majorItem.value || '',
                majorValue: majorValue,
                majorLeaderNames: majorDetail ? majorDetail.majorLeaderNames || '' : '',
                majorLeaderIds: majorDetail ? majorDetail.majorLeaderIds || '' : '',
                designerNames: majorDetail ? majorDetail.designerNames || '' : '',
                designerIds: majorDetail ? majorDetail.designerIds || '' : '',
                reviewerNames: majorDetail ? majorDetail.reviewerNames || '' : '',
                reviewerIds: majorDetail ? majorDetail.reviewerIds || '' : '',
                auditorNames: majorDetail ? majorDetail.auditorNames || '' : '',
                auditorIds: majorDetail ? majorDetail.auditorIds || '' : '',
                approverNames: majorDetail ? majorDetail.approverNames || '' : '',
                approverIds: majorDetail ? majorDetail.approverIds || '' : '',
                remark: ''
              });
            }
          }
        });
      });
      this.$set(this.form, 'subMajors', newSubMajors);
    },
    validateRequired() {
      const missing = [];
      if (!this.form.majorsArray || this.form.majorsArray.length === 0) {
        missing.push('参与专业');
      }
      if (!this.form.prjLeaderName) {
        missing.push('项目负责人');
      }
      if (!this.form.chiefEngineerName) {
        missing.push('项目分管总工');
      }
      if (!this.form.deptLeaderName) {
        missing.push('部门分管负责人');
      }
      if (!this.form.designReviewDate) {
        missing.push('设计评审时间');
      }
      if (!this.form.designInputDate) {
        missing.push('设计输入下达时间');
      }
      if (!this.form.drawingDate) {
        missing.push('出图时间');
      }
      if (!this.form.archiveDate) {
        missing.push('归档时间');
      }
      if (!this.form.designInputReq) {
        missing.push('设计输入要求');
      }
      if (!this.form.reviewOpinion) {
        missing.push('评审意见');
      }
      if (!this.form.reviewHostName) {
        missing.push('评审主持人');
      }
      if (!this.fileList || this.fileList.length === 0) {
        missing.push('附件');
      }
      return missing;
    },
    submitReview() {
      const missing = this.validateRequired();
      if (missing.length > 0) {
        this.$message.warning(`请先填写以下必填项：${missing.join('、')}`);
        return;
      }
      this.submitting = true;
      const { attachment, attachmentPaths } = buildAttachmentData(this.fileList);
      const dateFields = ['archiveDate', 'designInputDate', 'designReviewDate', 'drawingDate', 'requireFinishDate'];
      const params = {
        id: this.id,
        ...this.form,
        attachment,
        attachmentPaths,
        majors: this.normalizeMajors(this.form.majorsArray || this.form.majors),
        majorsDetail: (this.form.majorsDetail || []).map((item, i) => ({
          ...item,
          sortNo: i + 1
        })),
        subItems: (this.form.subItems || []).map(item => ({
          ...item,
          majors: this.normalizeMajors(item.majors),
          planEndDate: this.formatDate(item.planEndDate) || '-',
          subMajors: (this.form.subMajors || [])
              .filter(sm => sm._rowKey === item._rowKey || String(sm._rowKey).startsWith(String(item._rowKey) + '_'))
              .map((sm, i) => ({
                ...sm,
                sortNo: i + 1
              }))
        }))
      };
      dateFields.forEach(field => {
        params[field] = this.formatDate(params[field]);
      });
      delete params.majorsArray;
      delete params.subMajors;

      resubmitSimplePlan(params)
          .then(() => {
            this.$close(this.$route.path, "/approval/task");
          })
          .catch((e) => {
            console.error("提交失败详情", e);
            this.$message.error("提交失败");
          })
          .finally(() => {
            this.submitting = false;
          });
    },
    goBack() {
      this.$close(this.$route.path);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.wrapper {
  background-color: #f9f9f9;
  padding-top: 24px;
  padding-bottom: 8px;
}

.title {
  font-weight: bold;
  font-size: 17px;
  margin: 12px 0;
}

.center {
  margin-top: 80px;
  display: flex;
  justify-content: center;
}

.hintInit {
  max-width: 90%;
  margin: 0 auto 8px auto;
}

.hintName {
  color: #999;
  font-size: 13px;
}
</style>
